import { cn } from "@/lib/utils";

export function Divider({ className }: { className?: string }) {
  return <div className={cn("my-5 h-[1px] bg-[rgba(234,236,240,1)]", className)}></div>;
}
